import type { MouseEvent } from "react";

import {
  BaseButton,
  BaseLink,
} from "../styles/ButtonStyles";
import type {
  AnchorButtonProps,
  ButtonProps,
  NativeButtonProps,
} from "../styles/ButtonStyles";

const AnchorButton = ({
  data_testid,
  bgcolor,
  width,
  background = "fill",
  variant = "contained",
  $slim = false,
  disabled = false,
  href,
  target,
  rel,
  tabIndex,
  children,
  onClick,
  component: _component,
  ...anchorProps
}: AnchorButtonProps) => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      event.preventDefault();
      return;
    }

    onClick?.(event);
  };

  return (
    <BaseLink
      {...anchorProps}
      data-testid={data_testid}
      href={disabled ? undefined : href}
      target={target}
      rel={rel}
      tabIndex={disabled ? -1 : tabIndex}
      aria-disabled={disabled}
      $bgcolor={bgcolor}
      $width={width}
      $background={background}
      $variant={variant}
      $slim={$slim}
      $disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </BaseLink>
  );
};

const NativeButton = ({
  data_testid,
  bgcolor,
  width,
  background = "fill",
  variant = "contained",
  type = "button",
  $slim = false,
  disabled = false,
  children,
  component: _component,
  ...buttonProps
}: NativeButtonProps) => (
  <BaseButton
    {...buttonProps}
    data-testid={data_testid}
    type={type}
    disabled={disabled}
    $bgcolor={bgcolor}
    $width={width}
    $background={background}
    $variant={variant}
    $slim={$slim}
    $disabled={disabled}
  >
    {children}
  </BaseButton>
);

export const Button = (props: ButtonProps) => {
  if (props.component === "a") {
    return <AnchorButton {...props} />;
  }

  return <NativeButton {...props} />;
};

export default Button;
